import React, { useMemo } from 'react';
import { Box, Container } from '@material-ui/core';
import Map from '../../Components/Map';
import { useAuth } from '../../Contexts/AuthProvider';

const MapPage = () => {
  const { currentUser } = useAuth();
  const allowUiMap = useMemo(() => currentUser.allowUiMap(), [currentUser])

  if (!allowUiMap) {
    return (
      <main style={{ padding: '35px 15px' }}>
        <div className="pageBlock">
          <div className="pageCard">
            <div style={{ 
              textAlign: 'center', 
              padding: '40px 20px',
              fontSize: '16px',
              color: '#4444448f'
            }}>
              <div>
                {'You do not have permission to view this page'}
              </div>
            </div>
          </div>
        </div>
      </main>
    );
  }

  return (
    <Container maxWidth="xl" style={{ padding: '0px', overflow: 'hidden', width: '100vw', maxWidth: '100vw' }}>
      <Box>
        <Map />
      </Box>
    </Container>
  );
};

export default MapPage; 